<template>
  <table class="table table-striped table-hover headder-fixed">
    <thead>
      <tr>
        <th
          class="sticky-top"
          width="15%"
        >
          {{ __('Nome') }}
        </th>
        <th class="sticky-top">
          {{ __('Descrição') }}
        </th>
        <th
          class="sticky-top"
          width="10%"
        >
          {{ __('Preço mínimo (R$)') }}
        </th>
        <th
          class="center sticky-top"
          width="6%"
          v-if="can.update"
        >
          {{ __('Editar') }}
        </th>
        <th
          class="center sticky-top"
          width="6%"
          v-if="can.destroy"
        >
          {{ __('Excluir') }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="product in list.data">
        <td>{{ product.name | truncate(40) }}</td>
        <td>{{ product.description | truncate(100) }}</td>
        <td>{{ product.price | currency }}</td>
        <td
          class="text-center"
          v-if="can.update"
        >
          <a
            href="#"
            @click.prevent="edit(product)"
          >{{ __('Editar') }}</a>
        </td>
        <td
          class="text-center"
          v-if="can.destroy"
        >
          <a
            href="#"
            @click.prevent="destroy(product)"
          > {{ __('Excluir') }}</a>
        </td>
      </tr>
    </tbody>
    <BModal
      id="products-edit-modal"
      ref="products-edit-modal"
      hide-footer="hide-footer"
    >
      <template slot="modal-tite">
        {{ __('Editar Produto') }}
      </template>
      <template slot="default">
        <form
          role="form"
          @submit.prevent="save()"
        >
          <div
            class="form-group"
            :class="{ 'has-error': editForm.errors.has('name') }"
          >
            <input
              class="form-control"
              type="text"
              placeholder="Nome"
              name="name"
              v-model="editForm.name"
              required=""
            ><span
              class="form-text"
              v-show="editForm.errors.has('name')"
            >{{ editForm.errors.get('name') }}</span>
          </div>
          <div class="col-6">
            <div
              class="form-group"
              :class="{ 'has-error': editForm.errors.has('price') }"
            >
              <InputText
                class="form-control"
                mask="#.##0,00"
                type="text"
                :placeholder="`Preço ${__('R$')}`"
                name="price"
                v-model="editForm.price"
                required=""
              /><span
                class="form-text"
                v-show="editForm.errors.has('price')"
              >{{ editForm.errors.get('price') }}</span>
            </div>
          </div>
          <div class="col-12">
            <div
              class="form-group"
              :class="{ 'has-error': editForm.errors.has('description') }"
            >
              <textarea
                class="form-control"
                rows="5"
                placeholder="Descrição"
                name="description"
                v-model="editForm.description"
              /><span
                class="form-text"
                v-show="editForm.errors.has('description')"
              >{{ editForm.errors.get('description') }}</span>
            </div>
          </div>
          <div class="modal-footer default-modal-footer">
            <button
              class="btn btn-primary"
              type="submit"
              :disabled="status.saving"
            >
              <span v-if="!status.saving">{{ __('Salvar') }}</span><span v-if="status.saving">{{ __('Salvando') }}...</span>
            </button>
            <button
              class="btn btn-white"
              @click.prevent="closeModal()"
              :disabled="status.saving"
            >
              {{ __('Cancelar') }}
            </button>
          </div>
        </form>
      </template>
    </BModal>
  </table>
</template>

<script>
import { BModal } from 'bootstrap-vue';
import { Confirm } from '../../services/Confirm';

function addForm () {
  return {
    id: '',
    name: '',
    description: '',
    price: '',
  };
}

export default {
  components: {
    BModal,
  },

  props: ['products', 'can'],

  data () {
    return {
      list: this.products,
      status: {
        saving: false,
      },

      editForm: new BulldeskForm(addForm()),
    };
  },

  methods: {

    save () {
      Http.put(`/product/${this.editForm.id}`, this.editForm)
        .then((response) => {
          const list = this.list.data;
          const index = list.indexOf(list.filter((product) => product.id == response.id).pop());

          this.$set(this.list.data, index, response);
          this.editForm = new BulldeskForm(addForm());

          Alert.success(this.__('Produto editado com sucesso'));
          this.closeModal();
        });
    },

    edit (product) {
      this.editForm.id = product.id;
      this.editForm.name = product.name;
      this.editForm.description = product.description;
      this.editForm.price = this.number_format(product.price);

      this.$refs['products-edit-modal'].show();
    },

    async destroy (product) {
      if (! await Confirm(this.__('Deseja mesmo excluir este produto?'))) {
        return;
      }

      this.$http.delete(`/product/${product.id}`)
        .then(() => {
          this.list.data.splice(this.list.data.indexOf(product), 1);

          Alert.success(this.__('Produto excluido com sucesso!'));
        })
        .catch((error) => {
          Alert.error(error.data.message);
        });
    },

    number_format (number) {
      return number.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    },

    closeModal () {
      this.$refs['products-edit-modal'].hide();
    },
  },
};
</script>
